import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
} from "reactstrap";

const LeaveRequestModal = ({ isOpen, toggle }) => {
  const [name, setName] = useState("");
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [days, setDays] = useState("");
  const [className, setClassName] = useState("");

  const handleSubmit = () => {
    const finalReason = reason === "Other" ? customReason : reason;

    // console.log({
    //   name,
    //   reason: finalReason,
    //   days,
    //   className,
    // });
    toggle(); // Close the modal after submission
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Leave Request</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup row>
            <Label for="name" sm={3}>
              Name
            </Label>
            <Col sm={9}>
              <Input
                type="text"
                name="name"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="reason" sm={3}>
              Reason
            </Label>
            <Col sm={9}>
              <Input
                type="select"
                name="reason"
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              >
                <option value="">Select a reason</option>
              </Input>
            </Col>
          </FormGroup>
          {reason === "Other" && (
            <FormGroup row>
              <Label for="customReason" sm={3}>
                Specify Reason
              </Label>
              <Col sm={9}>
                <Input
                  type="text"
                  name="customReason"
                  id="customReason"
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                />
              </Col>
            </FormGroup>
          )}
          <FormGroup row>
            <Label for="days" sm={3}>
              Days
            </Label>
            <Col sm={9}>
              <Input
                type="number"
                name="days"
                id="days"
                value={days}
                onChange={(e) => setDays(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="class" sm={3}>
              Class
            </Label>
            <Col sm={9}>
              <Input
                type="text"
                name="class"
                id="class"
                value={className}
                onChange={(e) => setClassName(e.target.value)}
              />
            </Col>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit}>
          Submit
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LeaveRequestModal;
